import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { PillSelector } from "./PillSelector";

/**
 * An arts subject row card used in progress report forms.
 *
 * Props:
 *   nameField     - RHF field name for the subject-name text input
 *   planField     - RHF field name for the plan pill
 *   resultField   - RHF field name for the result pill
 *   placeholder   - Placeholder text for the subject-name input
 *   planOptions   - Array<{ value, label }> for the plan PillSelector
 *   resultOptions - Array<{ value, label }> for the result PillSelector
 *   control       - react-hook-form control
 */
export function ArtsRow({ nameField, planField, resultField, placeholder, planOptions, resultOptions, control }) {
  return (
    <div className="rounded-xl border border-border bg-card p-4 space-y-3">
      <FormField
        control={control}
        name={nameField}
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-xs text-muted-foreground font-medium uppercase tracking-wide">Subject Name</FormLabel>
            <FormControl>
              <Input placeholder={placeholder} {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <div className="space-y-1">
        <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">Plan</p>
        <FormField
          control={control}
          name={planField}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <PillSelector value={field.value} onChange={field.onChange} options={planOptions} />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
      <div className="space-y-1">
        <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">Result</p>
        <FormField
          control={control}
          name={resultField}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <PillSelector value={field.value} onChange={field.onChange} options={resultOptions} />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
